// extracted by mini-css-extract-plugin
module.exports = {"partsTable":"PartsTable_partsTable__87zlQ","row":"PartsTable_row__-4qdU","loader":"PartsTable_loader__1oFOI"};